<div id="pause" class="container" >
    <div id="spinner" class="child" ></div>
</div>